import "./App.css";
import Home from "./Components/Home";
import About from "./Components/About";
import Footer from "./Components/Footer";
import Services from "./Components/Services";
import Swipers from "./Components/Swiper";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Contact from "./Components/EnquiryForm";


import { ToastContainer } from "react-toastify";
import { FaWhatsapp } from 'react-icons/fa';
import { LanguageProvider } from "./i18n";





function App() {
  return (
    <LanguageProvider><div className="App">
      <Home />
    
      <About />

      <Services />
      <Swipers  />
      <Contact />
      <Footer />
      <a
        className="whatsapp-float"
        href="https://api.whatsapp.com/send?phone=918668012264&text=Hello%20Pranesh%20Enterprises%2C%20I%20would%20like%20to%20enquire%20about%20your%20laboratory%20equipment."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Pranesh Enterprises on WhatsApp"
        title="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>
      <ToastContainer
        autoClose={3000}
        closeOnClick
        pauseOnHover={false}
        closeButton={true}
      />
    </div></LanguageProvider>
  );
}

export default App;
